export default "__VITE_ASSET__68c6c6e4__"